import $ from "jquery";

const mainElement = document.querySelector(".js-faq__accordion");
if (mainElement) {
  $(function () {
    $(".accordion").click(function () {
      $(this).next().slideToggle();
      $(this).toggleClass("is-open");
    });
  });
}

